// import React, { useEffect, useState } from "react";
// import { Form } from "react-bootstrap";
// import axios from "axios";
// import { toast } from "react-toastify";
// import {
//   MDBSelect,
//   MDBCard,
//   MDBCardBody,
//   MDBCardTitle,
//   MDBValidation,
//   MDBCardImage,
//   MDBTextArea,
//   MDBBtn,
//   MDBInput,
//   MDBBadge,
//   div,
//   MDBInputGroup,
// } from "mdb-react-ui-kit";
// import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
// import dummyProfileImage from "../assets/images/dummyPhoto.png";
// import dummySignature from "../assets/images/dummySignature.png";
// import "../styles/fees.css";
// import formatDate from "../utilities/dateFormat";
// import fingerPrintServices from "../utilities/demo";
// import Test from "./Test";
// import CameraPopup from "../components/CameraPopup";
// import { clearImageData } from "../redux-toolkit/slices/imageSlice";
// import { useDispatch, useSelector } from "react-redux";
// import Loader from "../components/Loader";
// import convertToUnderscoreFormat from "../utilities/convertToUnderscoreFormat";
// import validateTemplateBase64Data from "../utilities/validateTemplateBase64Data";
// import API_BASE_URL from "../utilities/apiConfig";
// import ScannerLoader from "../components/ScannerLoader";
// import validatemembershipFeesFrom from "../utilities/validatemembershipFeesFrom";
// import { useNavigate } from "react-router-dom";
// import axiosInstance from "../utilities/apiConfig";
// import * as XLSX from "xlsx";

// // New page created for Welfare Fees. Mirrors the Fees.jsx form/layout.
// // Backend has no Welfare Fees API yet, so submit is UI-only (no real API call).
// const WelfareFees = () => {
//   const [id, setId] = useState(0);
//   const [barId, setbarId] = useState("");
//   const [template1, setTemplate1] = useState("");
//   const [template2, setTemplate2] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [secugenLic, setSecugenLic] = useState("");
//   const [quality, setQuality] = useState(100);
//   const [showFeesForm, setShowFeesForm] = useState(false);
//   const [profileImage, setProfileImage] = useState(dummyProfileImage);
//   const [signatureImage, setSignatureImage] = useState(dummySignature);
//   const [imageSrc1, setImageSrc1] = useState(dummyFingerprint);
//   const [refresh, setRefresh] = useState(0);
//   const [isFeeSlipPrintable, setIsFeeSlipPrintable] = useState(false);
//   const [imageSrc2, setImageSrc2] = useState(dummyFingerprint);
//   const [fingerPrintDB, setFingerPrintDB] = useState(false);
//   const [fingerPrintFees, setFingerPrintFees] = useState(false);
//   const [fingerPrintScanMessage, setFingerPrintScanMessage] = useState(true);
//   const [isFingerPrintScannerinProgress, setIsFingerPrintScannerinProgress] =
//     useState(false);
//   const [welfareStatus, setWelfareStatus] = useState(null);
//   const [paymentResult, setPaymentResult] = useState(null);
//   const [showReport, setShowReport] = useState(false);
//   const [reportRows, setReportRows] = useState([]);
//   const [reportSearch, setReportSearch] = useState("");
//   const [reportTypeFilter, setReportTypeFilter] = useState("");
//   const [feesBookAndSerialNo, setFeesBookAndSerialNo] = useState({
//     upcomingBookNo: 0,
//     upcomingSerialNo: 0,
//   });
//   const baseURL = axiosInstance.defaults.baseURL;

//   const initialUserData = {
//     verificationId: "",
//     name: "",
//     relationshipType: "S/O",
//     relativeName: "",
//     barAssociationId: "",
//     concernedBarRegistrationDate: "",
//     dateOfBirth: "",
//     advocateBarId: "",
//     mobileNo: "",
//     email: "",
//     experienceIn: "",
//     yearsOfExperience: "",
//     permanentAddress: "",
//     localAddress: "",
//     advocacyDocuments: "",
//     enrollmentNo: "",
//     enrollmentCertificate: "",
//     aibePassCertificateNo: "",
//     aibePassCertificate: "",
//     copNo: "",
//     copCertificate: "",
//     copValitidy: "",
//     aadharCertificate: "",
//     isAnotherBarMember: "",
//     barAssociationMembershipDetails: "",
//     mentorAdvocateName: "",
//     mentorAdvocateBarId: "",
//     joiningDate: "",
//     chamberNo: "",
//     photo: "",
//     fingerprint: "",
//     signature: "",
//     verificationDate: "",
//     status: "",
//   };

//   const initalFeesFormData = {
//     advocateBarId: "",
//     membershipTypeId: "",
//     memberType: "",
//     feesAmount: "",
//     userId: "",
//   };

//   const [feesFormData, setFeesFormData] = useState(initalFeesFormData);
//   const [userData, setUserData] = useState(initialUserData);
//   const fingerPrintService = fingerPrintServices();
//   const dispatch = useDispatch();
//   const token = useSelector((state) => state.auth.token);

//   const handleVerifyFingerPrint = async (fingerprint2) => {
//     try {
//       setLoading(true);
//       console.log("finger print data from welfare fees page ", fingerPrintFees);
//       console.log("finger print data from db", fingerPrintDB);
//       var data1Validation = validateTemplateBase64Data(fingerPrintDB);
//       var data2Validation = validateTemplateBase64Data(fingerprint2);
//       if (data2Validation && data1Validation) {
//         const response = await fingerPrintService.matchFingerPrint(
//           fingerPrintDB,
//           fingerprint2,
//           fingerPrintService.succMatch,
//           fingerPrintService.failureFunc
//         );
//         console.log("Response of Matching:", response);
//         if (response.matched) {
//           toast.success("Fingerprint verified ");
//           dispatch(clearImageData());
//           setFingerPrintScanMessage(false);
//         } else if (!response.matched) {
//           toast.error("Finger Print Does Not Matched");
//           setFingerPrintScanMessage(true);
//         }
//       } else {
//         toast.warning("Please Scan Your FingerPrint");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast.error("Error : Fingerprint  Not Verified Please try again");
//       // Handle the error here
//     } finally {
//       setLoading(false);
//     }
//   };

//   const imageData = useSelector((state) => state.profileimage?.imageData);
//   const userDeatils = useSelector((state) => state.auth?.userData?.authUser);

//   console.log("image data of Renewal fees page", imageData);

//   const containerStyle = {
//     display: "flex",
//     width: "100%",
//   };

//   const columnStyle = {
//     flex: 1,
//     textAlign: "center",
//   };

//   // Loads the paid (active) welfare fees and shows the report view with filters.
//   const handleViewWelfareReport = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(`/Welfare/get_paid_fees_data`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (response.data?.response?.statusCode === 200) {
//         const rows = response.data?.rows || [];
//         setReportRows(rows);
//         setReportSearch("");
//         setReportTypeFilter("");
//         setShowReport(true);
//         if (rows.length === 0) {
//           toast.warning("No active Renewal/Verification fees found");
//         }
//       } else {
//         toast.error(
//           response.data?.response?.status || "Could not load welfare report"
//         );
//       }
//     } catch (error) {
//       console.log("Error loading welfare report", error);
//       if (error.response?.status === 401) {
//         toast.error("Session expired. Please login again.");
//       } else {
//         toast.error("Could not load welfare report");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Downloads the currently filtered report rows as an Excel file.
//   const handleDownloadWelfareExcel = () => {
//     if (filteredReportRows.length === 0) {
//       toast.warning("No rows to download");
//       return;
//     }

//     const excelRows = filteredReportRows.map((r) => ({
//       "Bar ID": r.advocate_bar_id,
//       Name: r.name || "",
//       Relation: r.relationship_type || "",
//       "Relative Name": r.relative_name || "",
//       "Date of Birth": r.date_of_birth
//         ? new Date(r.date_of_birth).toLocaleDateString("en-GB")
//         : "",
//       "Mobile No": r.mobileno || "",
//       Email: r.email || "",
//       "Chamber No": r.chamber_no || "",
//       "Member Type": r.member_type || "",
//       "Fees Amount": r.fees_amount ?? "",
//       "Entry Date": r.entry_date
//         ? new Date(r.entry_date).toLocaleDateString("en-GB")
//         : "",
//       "Book No": r.book_no,
//       "Serial No": r.sr_no,
//       "Receipt No": r.receipt_no,
//       "Valid Till": r.valid_till
//         ? new Date(r.valid_till).toLocaleDateString("en-GB")
//         : "",
//       "Mentor Advocate": r.mentor_advocate_name || "",
//       "Mentor Bar ID": r.mentor_advocate_bar_id || "",
//       "Registration Date": r.concerned_bar_registration_date
//         ? new Date(r.concerned_bar_registration_date).toLocaleDateString(
//             "en-GB"
//           )
//         : "",
//       "Verification Date": r.verification_date
//         ? new Date(r.verification_date).toLocaleDateString("en-GB")
//         : "",
//       "Advocate Status": r.status || "",
//       "Permanent Address": r.permanent_address || "",
//       Status: r.result_code,
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(excelRows);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Welfare Paid Fees");
//     XLSX.writeFile(workbook, "Renewal/VerificationFeesReport.xlsx");
//     toast.success(`Excel report downloaded (${excelRows.length} records)`);
//   };

//   const handleGetUpcomingBookNoAndSerialNo = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(
//         `/Welfare/get_upcoming_book_no_and_serial_no`,
//         {
//           headers: {
//             accept: "*/*",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       console.log(response.data);
//       if (response.data.response.statusCode === 200) {
//         const { upcomingBookNo, upcomingSerialNo } = response.data;
//         console.log(upcomingBookNo, upcomingSerialNo);
//         setFeesBookAndSerialNo({ upcomingBookNo, upcomingSerialNo });
//       } else {
//         toast.error(response.data.response.status);
//       }
//     } catch (error) {
//       console.log("Error from welfare upcoming book no and serial no", error);
//       toast.error("Could not fetch upcoming welfare book no and serial no");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Welfare fee tiers as per usp_Welfare_InsertPayment: 200 = 1 year, 1000 = 5 years.
//   const handleWelfareTypeChange = (e) => {
//     const { value } = e.target;
//     if (value === "1") {
//       setFeesFormData({
//         ...feesFormData,
//         membershipTypeId: value,
//         memberType: "WELFARE YEARLY",
//         feesAmount: 200,
//       });
//     } else if (value === "2") {
//       setFeesFormData({
//         ...feesFormData,
//         membershipTypeId: value,
//         memberType: "WELFARE 5 YEARS",
//         feesAmount: 1000,
//       });
//     } else {
//       setFeesFormData({
//         ...feesFormData,
//         membershipTypeId: "",
//         memberType: "",
//         feesAmount: "",
//       });
//     }
//   };

//   const handleInputFieldChange = (e) => {
//     const { name, value } = e.target;

//     setUserData({
//       ...userData,
//       [name]: value,
//     });

//     setFeesFormData({
//       ...feesFormData,
//       [name]: value,
//     });

//     console.log("Handle Input Field Change", "=>", name, " : ", value);
//   };

//   const handleGetAdvocateFeesVerificationData = async () => {
//     try {
//       setLoading(true);
//       setFingerPrintScanMessage(true);
//       setIsFeeSlipPrintable(false);
//       setShowFeesForm(false);
//       setWelfareStatus(null);
//       setPaymentResult(null);

//       setUserData(initialUserData);
//       if (barId !== null) {
//         const formatted_bar_id = convertToUnderscoreFormat(barId);
//         console.log(formatted_bar_id);

//         // 1. Welfare eligibility check (verification + already-paid) via usp_Welfare_CheckAdvocate
//         const checkResponse = await axiosInstance.get(
//           `/Welfare/check_advocate/${formatted_bar_id}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         console.log("Welfare check response", checkResponse.data);
//         const { resultCode, message, validTill } = checkResponse.data;
//         setWelfareStatus({ resultCode, message, validTill });

//         if (resultCode === "NOT_VERIFIED") {
//           toast.error(message);
//           return;
//         }
//         // ALREADY_PAID: details are still fetched and shown, but view only (no payment until period over).
//         if (resultCode === "ALREADY_PAID") {
//           toast.warning(message);
//           setIsFeeSlipPrintable(true);
//         }

//         // 2. Fetch full verification data (fingerprint + images) to populate the form
//         const response = await axiosInstance.get(
//           `/Verification/${formatted_bar_id}`
//         );
//         console.log("Verifiaction data for Bar Id", response.data);
//         setUserData(response.data.advocateDetails);
//         console.log(response.data.advocateDetails?.advocateBarId);
//         setFeesFormData({
//           ...feesFormData,
//           advocateBarId: response.data.advocateDetails?.advocateBarId,
//         });
//         console.log(response.data.advocateDetails?.fingerprintData);
//         setFingerPrintDB(response.data.advocateDetails?.fingerprintData);

//         const imageUrl = `/Verification/${response.data?.advocateDetails?.photo}`;

//         try {
//           const response = await axiosInstance.get(imageUrl, {
//             responseType: "blob", // Important for image fetching
//           });

//           const imageBlob = URL.createObjectURL(response.data); // Create a URL for the blob
//           setProfileImage(imageBlob); // Set the image state
//         } catch (error) {
//           console.error("Error fetching profile image:", error);
//           setProfileImage(dummyProfileImage); // Fallback to dummy image on error
//         }

//         // Fetch and set the signature image
//         const signatureImageUrl = `/Verification/${response.data?.advocateDetails?.signature}`;

//         try {
//           const signatureResponse = await axiosInstance.get(signatureImageUrl, {
//             responseType: "blob", // Important for image fetching
//           });

//           const signatureBlob = URL.createObjectURL(signatureResponse.data); // Create a URL for the blob
//           setSignatureImage(signatureBlob); // Set the signature image state
//         } catch (error) {
//           console.error("Error fetching signature image:", error);
//           setSignatureImage(dummySignature); // Fallback to dummy signature on error
//         }

//         // Fetch and set the fingerprint image
//         const fingerprintImageUrl = `/Verification/${response.data?.advocateDetails?.fingerprintImage}`;

//         try {
//           const fingerprintResponse = await axios.get(fingerprintImageUrl, {
//             responseType: "blob", // Important for image fetching
//           });

//           const fingerprintBlob = URL.createObjectURL(fingerprintResponse.data); // Create a URL for the blob
//           setImageSrc2(fingerprintBlob); // Set the fingerprint image state
//         } catch (error) {
//           console.error("Error fetching fingerprint image:", error);
//           setImageSrc2(dummyFingerprint); // Fallback to dummy fingerprint on error
//         }

//         if (response.data.response.statusCode === 200) {
//           toast.success("Please Verify Your Details");

//           if (resultCode === "CAN_PAY") {
//             handleGetUpcomingBookNoAndSerialNo();
//           }
//           setShowFeesForm(true);
//         } else {
//           toast.error(response.data.response.status);
//         }
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       if (error.response?.status === 401) {
//         toast.error("Session expired. Please login again.");
//       } else {
//         toast.error(error.response?.data?.message || "An error occurred");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmitFees = async (e) => {
//     e.preventDefault();
//     console.log("sending the welfare fees form data", feesFormData);
//     const validationErrors = validatemembershipFeesFrom(feesFormData);
//     if (Object.keys(validationErrors).length > 0) {
//       Object.values(validationErrors).forEach((error) => {
//         toast.error(error);
//       });
//     } else {
//       if (!fingerPrintScanMessage) {
//         try {
//           setLoading(true);

//           const payload = {
//             advocateBarId: feesFormData.advocateBarId,
//             membershipTypeId: Number(feesFormData.membershipTypeId),
//             memberType: feesFormData.memberType,
//             feesAmount: Number(feesFormData.feesAmount),
//             barAssociationCode: userDeatils?.barAssociationId ?? 0,
//             userId: userDeatils?.userId,
//             // Editable only while a new book starts (serial no = 1); the proc ignores it otherwise
//             providedBookNo:
//               feesBookAndSerialNo?.upcomingSerialNo === 1 &&
//               feesBookAndSerialNo?.upcomingBookNo
//                 ? Number(feesBookAndSerialNo.upcomingBookNo)
//                 : null,
//           };
//           console.log("welfare payment payload", payload);

//           const response = await axiosInstance.post(
//             `/Welfare/payment`,
//             payload,
//             {
//               headers: {
//                 "Content-Type": "application/json; charset=utf-8",
//                 Authorization: `Bearer ${token}`, // Include the token in the request header
//               },
//             }
//           );
//           console.log(response.data);
//           // const { resultCode, message, bookNo, srNo, validTill } =response.data;
//           const { resultCode, message, recieptNo, validTill } =response.data;
//           if (resultCode === "SUCCESS") {
//             toast.success(message);
//             // setPaymentResult({ bookNo, srNo, validTill });
//             setPaymentResult({ recieptNo,  validTill });
//             setIsFeeSlipPrintable(true);
//             setShowFeesForm(false);
//             setFeesFormData(initalFeesFormData);
//           } else {
//             toast.error(message);
//           }
//         } catch (error) {
//           if (error.response?.status === 401) {
//             toast.error("Session expired. Please login again.");
//           } else if (error.response) {
//             toast.error(
//               error.response.data?.message || "Payment failed, please try again"
//             );
//           } else {
//             toast.error("An error occurred");
//           }
//           console.log("Welfare Fees Api Error", error);
//         } finally {
//           setLoading(false);
//         }
//       } else {
//         toast.warning("Please verify fingerprint");
//       }
//     }
//   };

//   const successFunc2 = (result) => {
//     setIsFingerPrintScannerinProgress(false);
//     if (result.ErrorCode === 0) {
//       if (result != null && result.BMPBase64.length > 0) {
//         setTemplate2(result.TemplateBase64);
//         setFingerPrintFees(result.TemplateBase64);
//         setImageSrc2("data:image/bmp;base64," + result.BMPBase64);
//         handleVerifyFingerPrint(result.TemplateBase64);
//       }
//     } else {
//       if (result.ErrorCode === 3) {
//         toast.error("Please check your fingerprint device");
//       } else if (result.ErrorCode === 54) {
//         toast.error("Timeout, scan your finger again");
//       } else {
//         toast.error("Please scan your finger again");
//       }
//       console.log("Finger print error in Renewal fees page ", result);
//     }
//   };

//   const errorFunc = (status) => {
//     setIsFingerPrintScannerinProgress(false);
//     toast.error("Please Check Secugen fingerprit service is working properly");
//   };

//   const callSGIFPGetData = (successCall, failCall) => {
//     setIsFingerPrintScannerinProgress(true);
//     const uri = "https://localhost:8000/SGIFPCapture";
//     const params = `Timeout=10000&Quality=50&licstr=${encodeURIComponent(
//       secugenLic
//     )}&templateFormat=ISO`;

//     fetch(uri, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//       body: params,
//     })
//       .then((response) => {
//         if (response.ok) {
//           return response.json();
//         } else {
//           throw new Error("Network response was not ok.");
//         }
//       })
//       .then((data) => {
//         successCall(data);
//       })
//       .catch((error) => {
//         failCall(error);
//       });
//   };

//   const matchScore = (succFunction, failFunction) => {
//     if (template1 === "" || template2 === "") {
//       alert("Please scan two fingers to verify!!");
//       return;
//     }
//     const uri = "https://localhost:8000/SGIMatchScore";

//     const params = `template1=${encodeURIComponent(
//       template1
//     )}&template2=${encodeURIComponent(template2)}&licstr=${encodeURIComponent(
//       secugenLic
//     )}&templateFormat=ISO`;

//     fetch(uri, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//       body: params,
//     })
//       .then((response) => {
//         if (response.ok) {
//           return response.json();
//         } else {
//           throw new Error("Network response was not ok.");
//         }
//       })
//       .then((data) => {
//         succFunction(data);
//       })
//       .catch((error) => {
//         failFunction(error);
//       });
//   };

//   const succMatch = (result) => {
//     const idQuality = quality;
//     if (result.ErrorCode === 0) {
//       if (result.MatchingScore >= idQuality) {
//         toast.success(`FingerPrint Matched Successfully`);
//       } else {
//         toast.error("Not Matched Try Again");
//       }
//     } else {
//       toast.error("Error Scanning Fingerprint");
//     }
//   };

//   const failureFunc = (error) => {
//     alert("On Match Process, failure has been called");
//   };

//   const errorCodeToString = (ErrorCode) => {
//     // Implement the ErrorCodeToString function here
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     setFeesFormData((prevState) => ({
//       ...prevState,
//       userId: userDeatils?.userId,
//     }));

//     console.log("User Id From Login Session", userDeatils?.userId);
//   }, [userDeatils]);

//   // ALREADY_PAID => details shown view-only; payment allowed again only after the period is over.
//   const isViewOnly = welfareStatus?.resultCode === "ALREADY_PAID";

//   // Report view: rows after applying the search / member-type filters.
//   const filteredReportRows = reportRows.filter((r) => {
//     const searchText = reportSearch.toLowerCase();
//     const matchesSearch =
//       !reportSearch ||
//       (r.advocate_bar_id || "").toLowerCase().includes(searchText) ||
//       (r.name || "").toLowerCase().includes(searchText);
//     const matchesType = !reportTypeFilter || r.member_type === reportTypeFilter;
//     return matchesSearch && matchesType;
//   });
//   const reportMemberTypes = [
//     ...new Set(reportRows.map((r) => r.member_type).filter(Boolean)),
//   ];

//   // Same blue as the existing header/sidebar theme.
//   const welfareAccentColor = "#60a0ff";
//   const welfareBtnStyle = {
//     backgroundColor: welfareAccentColor,
//     borderColor: welfareAccentColor,
//   };

//   return (
//     <>
//       {loading && <Loader />}
//       {isFingerPrintScannerinProgress && <ScannerLoader />}

//       <div
//         className="row justify-content-center"
//         style={{
//           backgroundColor: welfareAccentColor,
//           padding: "10px 0",
//           margin: 0,
//         }}
//       >
//         <div className="col-xxl-8 d-flex align-items-center justify-content-between">
//           <span className="text-white fw-bold">
//             <i className="ri-heart-2-fill me-2"></i>
//             RENEWAL/VERIFICATION FEES FORM
//           </span>
//           <div>
//             <MDBBtn
//               color="light"
//               size="sm"
//               className="me-2"
//               onClick={() => {
//                 handleViewWelfareReport();
//               }}
//             >
//               Excel Report
//             </MDBBtn>
//             <MDBBtn
//               color="light"
//               size="sm"
//               onClick={() => {
//                 navigate("/Fees");
//               }}
//             >
//               Back to Fees
//             </MDBBtn>
//           </div>
//         </div>
//       </div>

//       {showReport && (
//         <div className="row justify-content-center mt-4 mb-2">
//           <div className="col-xxl-10 col-11">
//             <div className="card p-3">
//               <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
//                 <h5 className="m-0" style={{ color: welfareAccentColor }}>
//                   <b>
//                     Renewal/Verification Paid Fees Report ({filteredReportRows.length} of{" "}
//                     {reportRows.length})
//                   </b>
//                 </h5>
//                 <div className="d-flex flex-wrap align-items-center gap-2">
//                   <input
//                     className="form-control form-control-sm"
//                     style={{ width: "180px" }}
//                     placeholder="Search Bar ID / Name"
//                     value={reportSearch}
//                     onChange={(e) => setReportSearch(e.target.value)}
//                   />
//                   <select
//                     className="form-select form-select-sm"
//                     style={{ width: "200px" }}
//                     value={reportTypeFilter}
//                     onChange={(e) => setReportTypeFilter(e.target.value)}
//                   >
//                     <option value="">All Member Types</option>
//                     {reportMemberTypes.map((t) => (
//                       <option key={t} value={t}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                   <MDBBtn
//                     size="sm"
//                     style={welfareBtnStyle}
//                     onClick={() => {
//                       handleDownloadWelfareExcel();
//                     }}
//                   >
//                     Download Excel
//                   </MDBBtn>
//                   <MDBBtn
//                     size="sm"
//                     color="secondary"
//                     onClick={() => {
//                       setShowReport(false);
//                     }}
//                   >
//                     Close
//                   </MDBBtn>
//                 </div>
//               </div>
//               <div style={{ maxHeight: "420px", overflow: "auto" }}>
//                 <table className="table table-striped table-bordered table-sm m-0">
//                   <thead
//                     style={{
//                       position: "sticky",
//                       top: 0,
//                       backgroundColor: "#fff",
//                     }}
//                   >
//                     <tr>
//                       <th>#</th>
//                       <th>Bar ID</th>
//                       <th>Name</th>
//                       <th>Mobile No</th>
//                       <th>Member Type</th>
//                       <th>Fees ₹</th>
//                       <th>Entry Date</th>
//                       <th>Book No</th>
//                       <th>Serial No</th>
//                       <th>Receipt No</th>
//                       <th>Valid Till</th>
//                       <th>Address</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredReportRows.map((r, i) => (
//                       <tr key={r.fee_id ?? i}>
//                         <td>{i + 1}</td>
//                         <td>{r.advocate_bar_id}</td>
//                         <td>{r.name}</td>
//                         <td>{r.mobileno}</td>
//                         <td>{r.member_type}</td>
//                         <td>{r.fees_amount}</td>
//                         <td>
//                           {r.entry_date
//                             ? new Date(r.entry_date).toLocaleDateString("en-GB")
//                             : ""}
//                         </td>
//                         <td>{r.book_no}</td>
//                         <td>{r.sr_no}</td>
//                         <td>{r.receipt_no}</td>
//                         <td>
//                           {r.valid_till
//                             ? new Date(r.valid_till).toLocaleDateString("en-GB")
//                             : ""}
//                         </td>
//                         <td
//                           style={{
//                             maxWidth: "260px",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                           }}
//                           title={r.permanent_address}
//                         >
//                           {r.permanent_address}
//                         </td>
//                       </tr>
//                     ))}
//                     {filteredReportRows.length === 0 && (
//                       <tr>
//                         <td colSpan="11" className="text-center">
//                           No records found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="row justify-content-center mb-2">
//         <div className="col-xxl-8 mt-5">
//           <h3 className="text-center mb-5" style={{ color: welfareAccentColor }}>
//             <b>Renewal/Verification Fees Submition</b>
//           </h3>
//         </div>
//       </div>

//       <div className="row justify-content-center mb-5">
//         <div className="col-xxl-8">
//           <div className="row justify-content-center">
//             <div
//               feedback="Please Enter Bar Id."
//               invalid
//               className="col-md-6 col-xl-4 col-xxl-3 mb-1 d-flex"
//             >
//               <MDBInput
//                 required
//                 value={barId}
//                 onChange={(e) => setbarId(e.target.value)}
//                 label="Enter Bar Id"
//                 type="text"
//                 name="barId"
//                 className="m-0"
//                 id="barId"
//               />
//             </div>

//             {isFeeSlipPrintable ? (
//               <div className="col-md-6 col-xl-5 col-xxl-4 mb-1">
//                 <MDBBtn
//                   style={welfareBtnStyle}
//                   onClick={() => {
//                     handleGetAdvocateFeesVerificationData();
//                   }}
//                 >
//                   Get Data
//                 </MDBBtn>{" "}
//               </div>
//             ) : (
//               <div className="col-md-4 mb-1 ">
//                 <MDBBtn
//                   style={welfareBtnStyle}
//                   onClick={() => {
//                     handleGetAdvocateFeesVerificationData();
//                   }}
//                 >
//                   Get Data
//                 </MDBBtn>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {welfareStatus?.resultCode === "ALREADY_PAID" && (
//         <div className="row justify-content-center mb-3">
//           <div className="col-xxl-8 text-center">
//             <span className="badge rounded-pill bg-success p-2">
//               {welfareStatus?.message}
//             </span>{" "}
//             <MDBBtn
//               style={welfareBtnStyle}
//               size="sm"
//               onClick={() => {
//                 navigate(`/WelfareSlip/${convertToUnderscoreFormat(barId)}`);
//               }}
//             >
//               Print Renewal/Verification Slip
//             </MDBBtn>
//           </div>
//         </div>
//       )}

//       {paymentResult && (
//         <div className="row justify-content-center mb-3">
//           <div className="col-xxl-8 text-center">
//             {/* <span className="badge rounded-pill bg-success p-2">
//               Payment Successful — Book No: {paymentResult.bookNo} | Serial No:{" "}
//               {paymentResult.srNo} | Valid Till:{" "}
//               {new Date(paymentResult.validTill).toLocaleDateString("en-GB")}
//             </span>{" "} */}
//                <span className="badge rounded-pill bg-success p-2">
//               Payment Successful — RECEIPT No: {paymentResult.recieptNo}  | Valid Till:{" "}
//               {new Date(paymentResult.validTill).toLocaleDateString("en-GB")}
//             </span>{" "}
//             <MDBBtn
//               style={welfareBtnStyle}
//               size="sm"
//               onClick={() => {
//                 navigate(`/WelfareSlip/${convertToUnderscoreFormat(barId)}`);
//               }}
//             >
//               Print Renewal/Verification Slip
//             </MDBBtn>
//           </div>
//         </div>
//       )}

//       <div className="row p-3 mt-4 justify-content-center ">
//         {showFeesForm && (
//           <>
//             <div className="row justify-content-center mb-3">
//               <div className="col-sm-6 col-md-3 col-xxl-2">
//                 <MDBInput
//                   label="Enter Name"
//                   id="name"
//                   name="name"
//                   value={userData?.name}
//                   type="text"
//                 />
//               </div>

//               <div className="col-sm-6 col-md-3 col-xxl-2">
//                 <div className="input-group mb-3">
//                   <select
//                     className="form-select form-select-sm py-0"
//                     style={{
//                       height: "calc(1.5em + 0.75rem + 2px)",
//                       width: "35%",
//                     }}
//                     value={userData?.relationshipType}
//                     name="relationshipType"
//                     id="relationshipType"
//                   >
//                     <option value="Son">S/O</option>
//                     <option value="Daughter">D/O</option>
//                     <option value="Wife">W/O</option>
//                   </select>

//                   <div className="input-group-append" style={{ width: "65%" }}>
//                     <MDBInput
//                       label="Relative Name"
//                       id="relativeName"
//                       name="relativeName"
//                       value={userData?.relativeName}
//                       type="text"
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="col-sm-6 col-md-3 col-xxl-2">
//                 <MDBInput
//                   label="Date of Birth"
//                   id="dateOfBirth"
//                   name="dateOfBirth"
//                   value={userData?.dateOfBirth}
//                   type="date"
//                 />
//               </div>
//               <div className="col-sm-6 col-md-3 col-xxl-2">
//                 <MDBInput
//                   label="Phone No"
//                   id="mobileNo"
//                   name="mobileNo"
//                   value={userData?.mobileNo}
//                   type="text"
//                 />
//               </div>
//             </div>

//             {!isViewOnly && (
//               <div className="row justify-content-center mb-2">
//                 <div className="col-xxl-8">
//                   <div className="row">
//                     <div className="col-md-3">
//                       <label className="form-label" for="subscription__type">
//                         Renewal/Verification Fee Type
//                       </label>

//                       <select
//                         className="form-select"
//                         onChange={handleWelfareTypeChange}
//                         value={feesFormData?.membershipTypeId}
//                         name="membershipTypeId"
//                         id="membershipTypeId"
//                       >
//                         <option value="" selected>
//                           Select
//                         </option>
//                         <option className="mb-3" value="1">
//                           1 Year (₹200)
//                         </option>
//                         <option className="mb-3" value="2">
//                           5 Years (₹1000)
//                         </option>
//                       </select>
//                     </div>

//                     <div className="col-md-3 mt-auto d-flex">
//                       <MDBInput
//                         value={feesFormData?.feesAmount}
//                         name="feesAmount"
//                         className="mb-0 d-inline"
//                         id="feesAmount"
//                         label="Total Amount in ₹"
//                         type="number"
//                         readOnly
//                         required
//                       />
//                     </div>

//                     {/* <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
//                       <label className="form-label" for="subscription__type">
//                         Upcoming Book No & Serial No
//                       </label>
//                       <div>
//                         <div className="input-group" style={containerStyle}>
//                           <input
//                             value={feesBookAndSerialNo?.upcomingBookNo}
//                             className="form-control"
//                             readOnly={
//                               feesBookAndSerialNo?.upcomingSerialNo !== 1
//                             }
//                             onChange={(e) => {
//                               setFeesBookAndSerialNo({
//                                 ...feesBookAndSerialNo,
//                                 upcomingBookNo: e.target.value,
//                               });
//                             }}
//                             style={columnStyle}
//                             type="number"
//                           />
//                           <div
//                             className="input-group-append"
//                             style={columnStyle}
//                           >
//                             <span className="input-group-text">
//                               {feesBookAndSerialNo?.upcomingSerialNo}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div> */}

//                     <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
//                       {welfareStatus?.resultCode === "CAN_PAY" && (
//                         <>
//                           <strong>Renewal/Verification Fee Status : </strong>
//                           <span className="badge rounded-pill badge-info bg-success">
//                             Eligible to Pay
//                           </span>
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="row justify-content-center mb-2">
//               <div className="col-xxl-8">
//                 <div data-mdb-input-init className="form-outline">
//                   <label className="form-label" htmlFor="textAreaExample3">
//                     Permanent Address
//                   </label>
//                   <MDBTextArea
//                     className="form-control"
//                     id="permanentAddress"
//                     name="permanentAddress"
//                     value={userData?.permanentAddress}
//                     rows="2"
//                   ></MDBTextArea>
//                 </div>
//               </div>
//             </div>

//             {!isViewOnly && (
//               <div className="row justify-content-center mb-2">
//                 <div className="col-xxl-8">
//                   {fingerPrintScanMessage ? (
//                     <div className="text-danger">
//                       Please verify your fingerprint before fees form submission
//                     </div>
//                   ) : (
//                     <div className="text-success">
//                       Your fingerprint is verified Please submit your fees form{" "}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}

//             <div className="row justify-content-center my-2">
//               <div className="col-xxl-8">
//                 <div className="row">
//                   <div className="col-xl-2 col-md-3 col-sm-4">
//                     <MDBCard>
//                       <MDBCardBody>
//                         <MDBBtn>+</MDBBtn>
//                       </MDBCardBody>
//                       <div className="square-aspect-ratio-container">
//                         <img
//                           src={profileImage}
//                           className="rounded-circle mb-1 img-fluid"
//                           alt="Avatar"
//                         />
//                       </div>
//                       <MDBCardBody className="m-0 p-0">
//                         <MDBCardTitle className="text-center p-0 my-2">
//                           Photo
//                         </MDBCardTitle>
//                       </MDBCardBody>
//                     </MDBCard>
//                   </div>
//                   <div className="col-xl-2 col-md-3 col-sm-4">
//                     <MDBCard>
//                       <MDBCardBody>
//                         <MDBBtn
//                           onClick={() =>
//                             callSGIFPGetData(successFunc2, errorFunc)
//                           }
//                         >
//                           +
//                         </MDBBtn>
//                       </MDBCardBody>
//                       <div className="square-aspect-ratio-container">
//                         <img
//                           src={imageSrc2}
//                           className="rounded-circle mb-1 img-fluid"
//                           alt="Avatar"
//                         />
//                       </div>
//                       <MDBCardBody className="m-0 p-0">
//                         <MDBCardTitle className="text-center p-0 my-2">
//                           Fingerprint
//                         </MDBCardTitle>
//                       </MDBCardBody>
//                     </MDBCard>
//                   </div>
//                   <div className="col-xl-2 col-md-3 col-sm-4">
//                     <MDBCard>
//                       <MDBCardBody>
//                         <MDBBtn>+</MDBBtn>
//                       </MDBCardBody>
//                       <div className="square-aspect-ratio-container">
//                         <img
//                           src={signatureImage}
//                           className="rounded-circle mb-1 img-fluid"
//                           alt="Avatar"
//                         />
//                       </div>

//                       <MDBCardBody className="m-0 p-0">
//                         <MDBCardTitle className="text-center p-0 my-2">
//                           Signature
//                         </MDBCardTitle>
//                       </MDBCardBody>
//                     </MDBCard>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {!isViewOnly && (
//               <div className="row justify-content-center my-5">
//                 <div className="col-md-2 mb-1">
//                   <MDBBtn
//                     style={welfareBtnStyle}
//                     onClick={(e) => {
//                       handleSubmitFees(e);
//                     }}
//                   >
//                     Submit
//                   </MDBBtn>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </>
//   );
// };

// export default WelfareFees;



import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import {
  MDBSelect,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBValidation,
  MDBCardImage,
  MDBTextArea,
  MDBBtn,
  MDBInput,
  MDBBadge,
  div,
  MDBInputGroup,
} from "mdb-react-ui-kit";
import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
import dummyProfileImage from "../assets/images/dummyPhoto.png";
import dummySignature from "../assets/images/dummySignature.png";
import "../styles/fees.css";
import formatDate from "../utilities/dateFormat";
import fingerPrintServices from "../utilities/demo";
import Test from "./Test";
import CameraPopup from "../components/CameraPopup";
import { clearImageData } from "../redux-toolkit/slices/imageSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import convertToUnderscoreFormat from "../utilities/convertToUnderscoreFormat";
import validateTemplateBase64Data from "../utilities/validateTemplateBase64Data";
import API_BASE_URL from "../utilities/apiConfig";
import ScannerLoader from "../components/ScannerLoader";
import validatemembershipFeesFrom from "../utilities/validatemembershipFeesFrom";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utilities/apiConfig";
import * as XLSX from "xlsx";
import getMembershipValidity from "../utilities/membershipValidity";

// New page created for Welfare Fees. Mirrors the Fees.jsx form/layout.
const WelfareFees = () => {
  const [id, setId] = useState(0);
  const [barId, setbarId] = useState("");
  const [template1, setTemplate1] = useState("");
  const [template2, setTemplate2] = useState("");
  const [loading, setLoading] = useState(false);
  const [secugenLic, setSecugenLic] = useState("");
  const [quality, setQuality] = useState(100);
  const [showFeesForm, setShowFeesForm] = useState(false);
  const [profileImage, setProfileImage] = useState(dummyProfileImage);
  const [signatureImage, setSignatureImage] = useState(dummySignature);
  const [imageSrc1, setImageSrc1] = useState(dummyFingerprint);
  const [refresh, setRefresh] = useState(0);
  const [isFeeSlipPrintable, setIsFeeSlipPrintable] = useState(false);
  const [imageSrc2, setImageSrc2] = useState(dummyFingerprint);
  const [fingerPrintDB, setFingerPrintDB] = useState(false);
  const [fingerPrintFees, setFingerPrintFees] = useState(false);
  const [fingerPrintScanMessage, setFingerPrintScanMessage] = useState(true);
  const [isFingerPrintScannerinProgress, setIsFingerPrintScannerinProgress] =
    useState(false);
  const [welfareStatus, setWelfareStatus] = useState(null);
  const [paymentResult, setPaymentResult] = useState(null);
  const [showReport, setShowReport] = useState(false);
  const [reportRows, setReportRows] = useState([]);
  const [reportSearch, setReportSearch] = useState("");
  const [reportTypeFilter, setReportTypeFilter] = useState("");
  const [feesBookAndSerialNo, setFeesBookAndSerialNo] = useState({
    upcomingBookNo: 0,
    upcomingSerialNo: 0,
  });
  // Normal (membership) fees validity, same as shown on the Fees page.
  const [membershipFeesDetails, setMembershipFeesDetails] = useState("");
  const [membershipValidity, setMembershipValidity] = useState("");
  // Yearly membership session status (/LoginFees/check_fees_session) for the validity badge
  const [membershipFeesSession, setMembershipFeesSession] = useState(null);
  // Session being paid: 1 = previous, 2 = current (sent as @mode)
  const [paymentMode, setPaymentMode] = useState(2);
  const baseURL = axiosInstance.defaults.baseURL;

  const initialUserData = {
    verificationId: "",
    name: "",
    relationshipType: "S/O",
    relativeName: "",
    barAssociationId: "",
    concernedBarRegistrationDate: "",
    dateOfBirth: "",
    advocateBarId: "",
    mobileNo: "",
    email: "",
    experienceIn: "",
    yearsOfExperience: "",
    permanentAddress: "",
    localAddress: "",
    advocacyDocuments: "",
    enrollmentNo: "",
    enrollmentCertificate: "",
    aibePassCertificateNo: "",
    aibePassCertificate: "",
    copNo: "",
    copCertificate: "",
    copValitidy: "",
    aadharCertificate: "",
    isAnotherBarMember: "",
    barAssociationMembershipDetails: "",
    mentorAdvocateName: "",
    mentorAdvocateBarId: "",
    joiningDate: "",
    chamberNo: "",
    photo: "",
    fingerprint: "",
    signature: "",
    verificationDate: "",
    status: "",
  };

  const initalFeesFormData = {
    advocateBarId: "",
    membershipTypeId: "",
    memberType: "",
    feesAmount: "",
    userId: "",
  };

  const [feesFormData, setFeesFormData] = useState(initalFeesFormData);
  const [userData, setUserData] = useState(initialUserData);
  const fingerPrintService = fingerPrintServices();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  const handleVerifyFingerPrint = async (fingerprint2) => {
    try {
      setLoading(true);
      console.log("finger print data from welfare fees page ", fingerPrintFees);
      console.log("finger print data from db", fingerPrintDB);
      var data1Validation = validateTemplateBase64Data(fingerPrintDB);
      var data2Validation = validateTemplateBase64Data(fingerprint2);
      if (data2Validation && data1Validation) {
        const response = await fingerPrintService.matchFingerPrint(
          fingerPrintDB,
          fingerprint2,
          fingerPrintService.succMatch,
          fingerPrintService.failureFunc
        );
        console.log("Response of Matching:", response);
        if (response.matched) {
          toast.success("Fingerprint verified ");
          dispatch(clearImageData());
          setFingerPrintScanMessage(false);
        } else if (!response.matched) {
          toast.error("Finger Print Does Not Matched");
          setFingerPrintScanMessage(true);
        }
      } else {
        toast.warning("Please Scan Your FingerPrint");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error : Fingerprint  Not Verified Please try again");
    } finally {
      setLoading(false);
    }
  };

  const imageData = useSelector((state) => state.profileimage?.imageData);
  const userDeatils = useSelector((state) => state.auth?.userData?.authUser);

  console.log("image data of Renewal fees page", imageData);

  const containerStyle = {
    display: "flex",
    width: "100%",
  };

  const columnStyle = {
    flex: 1,
    textAlign: "center",
  };

  // Loads the paid (active) welfare fees and shows the report view with filters.
  const handleViewWelfareReport = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/Welfare/get_paid_fees_data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data?.response?.statusCode === 200) {
        const rows = response.data?.rows || [];
        setReportRows(rows);
        setReportSearch("");
        setReportTypeFilter("");
        setShowReport(true);
        if (rows.length === 0) {
          toast.warning("No active Renewal/Verification fees found");
        }
      } else {
        toast.error(
          response.data?.response?.status || "Could not load welfare report"
        );
      }
    } catch (error) {
      console.log("Error loading welfare report", error);
      if (error.response?.status === 401) {
        toast.error("Session expired. Please login again.");
      } else {
        toast.error("Could not load welfare report");
      }
    } finally {
      setLoading(false);
    }
  };

  // Downloads the currently filtered report rows as an Excel file.
  const handleDownloadWelfareExcel = () => {
    if (filteredReportRows.length === 0) {
      toast.warning("No rows to download");
      return;
    }

    const excelRows = filteredReportRows.map((r) => ({
      "Bar ID": r.advocate_bar_id,
      Name: r.name || "",
      Relation: r.relationship_type || "",
      "Relative Name": r.relative_name || "",
      "Date of Birth": r.date_of_birth
        ? new Date(r.date_of_birth).toLocaleDateString("en-GB")
        : "",
      "Mobile No": r.mobileno || "",
      Email: r.email || "",
      "Chamber No": r.chamber_no || "",
      "Member Type": r.member_type || "",
      "Fees Amount": r.fees_amount ?? "",
      "Entry Date": r.entry_date
        ? new Date(r.entry_date).toLocaleDateString("en-GB")
        : "",
      "Book No": r.book_no,
      "Serial No": r.sr_no,
      "Receipt No": r.receipt_no,
      "Valid Till": r.valid_till
        ? new Date(r.valid_till).toLocaleDateString("en-GB")
        : "",
      "Mentor Advocate": r.mentor_advocate_name || "",
      "Mentor Bar ID": r.mentor_advocate_bar_id || "",
      "Registration Date": r.concerned_bar_registration_date
        ? new Date(r.concerned_bar_registration_date).toLocaleDateString(
            "en-GB"
          )
        : "",
      "Verification Date": r.verification_date
        ? new Date(r.verification_date).toLocaleDateString("en-GB")
        : "",
      "Advocate Status": r.status || "",
      "Permanent Address": r.permanent_address || "",
      Status: r.result_code,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Welfare Paid Fees");
    XLSX.writeFile(workbook, "Renewal_Verification_Fees_Report.xlsx");
    toast.success(`Excel report downloaded (${excelRows.length} records)`);
  };

  const handleGetUpcomingBookNoAndSerialNo = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Welfare/get_upcoming_book_no_and_serial_no`,
        {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response.data);
      if (response.data.response.statusCode === 200) {
        const { upcomingBookNo, upcomingSerialNo } = response.data;
        console.log(upcomingBookNo, upcomingSerialNo);
        setFeesBookAndSerialNo({ upcomingBookNo, upcomingSerialNo });
      } else {
        toast.error(response.data.response.status);
      }
    } catch (error) {
      console.log("Error from welfare upcoming book no and serial no", error);
      toast.error("Could not fetch upcoming welfare book no and serial no");
    } finally {
      setLoading(false);
    }
  };

  // Welfare fee tiers as per usp_Welfare_InsertPayment: 200 = 1 year, 1000 = 5 years.
  const handleWelfareTypeChange = (e) => {
    const { value } = e.target;
    if (value === "1") {
      setFeesFormData({
        ...feesFormData,
        membershipTypeId: value,
        memberType: "WELFARE YEARLY",
        feesAmount: 200,
      });
    } else if (value === "2") {
      setFeesFormData({
        ...feesFormData,
        membershipTypeId: value,
        memberType: "WELFARE 5 YEARS",
        feesAmount: 1000,
      });
    } else {
      setFeesFormData({
        ...feesFormData,
        membershipTypeId: "",
        memberType: "",
        feesAmount: "",
      });
    }
  };

  // Session labels (1 Sep .. 31 Aug), same calculation as the welfare procs.
  const today = new Date();
  const currentSessionEndYear =
    today.getMonth() >= 8 ? today.getFullYear() + 1 : today.getFullYear();
  const currentSessionLabel = `${currentSessionEndYear - 1}-${currentSessionEndYear}`;
  const previousSessionLabel = `${currentSessionEndYear - 2}-${currentSessionEndYear - 1}`;

  // Member registered in this bar on/after 1 Sep of the current session => not eligible for previous session.
  const currentSessionStart = new Date(currentSessionEndYear - 1, 8, 1);
  const barRegistrationDate = userData?.concernedBarRegistrationDate
    ? new Date(userData.concernedBarRegistrationDate)
    : null;
  const isNewMemberInCurrentSession =
    !!barRegistrationDate &&
    !isNaN(barRegistrationDate) &&
    barRegistrationDate >= currentSessionStart;

  useEffect(() => {
    if (isNewMemberInCurrentSession && paymentMode === 1) {
      setPaymentMode(2);
    }
  }, [isNewMemberInCurrentSession, paymentMode]);

  // usp_Welfare_CheckAdvocate: PAY_PREVIOUS (payment_mode 1), PAY_CURRENT (2),
  // ALREADY_PAID_CURRENT (nothing due), NOT_VERIFIED.
  const fetchWelfareStatus = async (formatted_bar_id) => {
    const checkResponse = await axiosInstance.get(
      `/Welfare/check_advocate/${formatted_bar_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Welfare check response", checkResponse.data);
    const { resultCode, message, validTill, paymentMode } = checkResponse.data;
    const status = { resultCode, message, validTill, paymentMode };
    setWelfareStatus(status);
    setPaymentMode(paymentMode === 1 ? 1 : 2);
    return status;
  };

  const handleInputFieldChange = (e) => {
    const { name, value } = e.target;

    setUserData({
      ...userData,
      [name]: value,
    });

    setFeesFormData({
      ...feesFormData,
      [name]: value,
    });

    console.log("Handle Input Field Change", "=>", name, " : ", value);
  };

  const handleGetAdvocateFeesVerificationData = async () => {
    try {
      setLoading(true);
      setFingerPrintScanMessage(true);
      setIsFeeSlipPrintable(false);
      setShowFeesForm(false);
      setWelfareStatus(null);
      setPaymentResult(null);
      setMembershipFeesDetails("");
      setMembershipValidity("");
      setMembershipFeesSession(null);
      setPaymentMode(2);
      setFeesFormData((prev) => ({
        ...prev,
        membershipTypeId: "",
        memberType: "",
        feesAmount: "",
      }));

      setUserData(initialUserData);
      if (barId !== null) {
        const formatted_bar_id = convertToUnderscoreFormat(barId);
        console.log(formatted_bar_id);

        // 1. Welfare eligibility check (verification + session status) via usp_Welfare_CheckAdvocate
        const { resultCode, message } = await fetchWelfareStatus(
          formatted_bar_id
        );

        if (resultCode === "NOT_VERIFIED") {
          toast.error(message);
          return;
        }
        // ALREADY_PAID_CURRENT: details are still fetched and shown, but view only.
        if (resultCode === "ALREADY_PAID_CURRENT") {
          toast.warning(message);
          setIsFeeSlipPrintable(true);
        }
        if (resultCode === "PAY_PREVIOUS") {
          toast.warning(message);
        }

        // 2. Fetch full verification data (fingerprint + images) to populate the form
        const response = await axiosInstance.get(
          `/Verification/${formatted_bar_id}`
        );
        console.log("Verifiaction data for Bar Id", response.data);
        setUserData(response.data.advocateDetails);
        console.log(response.data.advocateDetails?.advocateBarId);

        // Normal membership fees validity (same logic as Fees.jsx)
        setMembershipFeesDetails(response.data?.feesdetails);
        try {
          const sessionResponse = await axiosInstance.get(
            `/LoginFees/check_fees_session/${formatted_bar_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setMembershipFeesSession(sessionResponse.data);
        } catch (error) {
          console.error("Error fetching membership fees session:", error);
        }
        if (
          response.data?.feesdetails?.feesStatusCode === 202 &&
          response.data?.feesvalidity
        ) {
          setMembershipValidity(response.data?.feesvalidity);
        } else if (response.data?.feesdetails?.feesStatusCode === 200) {
          setMembershipValidity("LifeTime");
        } else {
          setMembershipValidity("Not Submitted");
        }

        setFeesFormData({
          ...feesFormData,
          advocateBarId: response.data.advocateDetails?.advocateBarId,
        });
        console.log(response.data.advocateDetails?.fingerprintData);
        setFingerPrintDB(response.data.advocateDetails?.fingerprintData);

        const imageUrl = `/Verification/${response.data?.advocateDetails?.photo}`;

        try {
          const response = await axiosInstance.get(imageUrl, {
            responseType: "blob", // Important for image fetching
          });

          const imageBlob = URL.createObjectURL(response.data);
          setProfileImage(imageBlob);
        } catch (error) {
          console.error("Error fetching profile image:", error);
          setProfileImage(dummyProfileImage);
        }

        // Fetch and set the signature image
        const signatureImageUrl = `/Verification/${response.data?.advocateDetails?.signature}`;

        try {
          const signatureResponse = await axiosInstance.get(signatureImageUrl, {
            responseType: "blob",
          });

          const signatureBlob = URL.createObjectURL(signatureResponse.data);
          setSignatureImage(signatureBlob);
        } catch (error) {
          console.error("Error fetching signature image:", error);
          setSignatureImage(dummySignature);
        }

        // Fetch and set the fingerprint image
        const fingerprintImageUrl = `/Verification/${response.data?.advocateDetails?.fingerprintImage}`;

        try {
          const fingerprintResponse = await axios.get(fingerprintImageUrl, {
            responseType: "blob",
          });

          const fingerprintBlob = URL.createObjectURL(fingerprintResponse.data);
          setImageSrc2(fingerprintBlob);
        } catch (error) {
          console.error("Error fetching fingerprint image:", error);
          setImageSrc2(dummyFingerprint);
        }

        if (response.data.response.statusCode === 200) {
          toast.success("Please Verify Your Details");

          if (resultCode === "PAY_PREVIOUS" || resultCode === "PAY_CURRENT") {
            handleGetUpcomingBookNoAndSerialNo();
          }
          setShowFeesForm(true);
        } else {
          toast.error(response.data.response.status);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response?.status === 401) {
        toast.error("Session expired. Please login again.");
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitFees = async (e) => {
    e.preventDefault();
    console.log("sending the welfare fees form data", feesFormData);
    const validationErrors = validatemembershipFeesFrom(feesFormData);
    if (Object.keys(validationErrors).length > 0) {
      Object.values(validationErrors).forEach((error) => {
        toast.error(error);
      });
    } else if (isNewMemberInCurrentSession && paymentMode === 1) {
      toast.error("New member of current session cannot pay previous session fee");
    } else {
      if (!fingerPrintScanMessage) {
        try {
          setLoading(true);

          const payload = {
            advocateBarId: feesFormData.advocateBarId,
            membershipTypeId: Number(feesFormData.membershipTypeId),
            memberType: feesFormData.memberType,
            feesAmount: Number(feesFormData.feesAmount),
            barAssociationCode: userDeatils?.barAssociationId ?? 0,
            userId: userDeatils?.userId,
            // Editable only while a new book starts (serial no = 1); the proc ignores it otherwise
            providedBookNo:
              feesBookAndSerialNo?.upcomingSerialNo === 1 &&
              feesBookAndSerialNo?.upcomingBookNo
                ? Number(feesBookAndSerialNo.upcomingBookNo)
                : null,
            // 1 = previous session, 2 = current session
            mode: paymentMode,
          };
          console.log("welfare payment payload", payload);

          const response = await axiosInstance.post(
            `/Welfare/payment`,
            payload,
            {
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          console.log(response.data);
          const { resultCode, message, recieptNo, validTill } = response.data;
          if (resultCode === "SUCCESS") {
            toast.success(message);
            setPaymentResult({ recieptNo, validTill });
            setIsFeeSlipPrintable(true);

            // Clear only the fee inputs; keep bar id / user id so the slip route still works.
            setFeesFormData((prev) => ({
              ...initalFeesFormData,
              advocateBarId: prev.advocateBarId,
              userId: prev.userId,
            }));

            // Re-check the status: after a previous-session payment the current
            // session becomes payable (PAY_CURRENT); otherwise the form locks.
            try {
              const status = await fetchWelfareStatus(
                convertToUnderscoreFormat(barId)
              );
              if (status.resultCode === "PAY_CURRENT") {
                toast.info("Previous session paid. Now pay the current session.");
              }
            } catch (error) {
              console.log("Error refreshing welfare status", error);
              setWelfareStatus({
                resultCode: "ALREADY_PAID_CURRENT",
                message,
                validTill,
              });
            }
          } else {
            toast.error(message);
          }
        } catch (error) {
          if (error.response?.status === 401) {
            toast.error("Session expired. Please login again.");
          } else if (error.response) {
            toast.error(
              error.response.data?.message || "Payment failed, please try again"
            );
          } else {
            toast.error("An error occurred");
          }
          console.log("Welfare Fees Api Error", error);
        } finally {
          setLoading(false);
        }
      } else {
        toast.warning("Please verify fingerprint");
      }
    }
  };

  const successFunc2 = (result) => {
    setIsFingerPrintScannerinProgress(false);
    if (result.ErrorCode === 0) {
      if (result != null && result.BMPBase64.length > 0) {
        setTemplate2(result.TemplateBase64);
        setFingerPrintFees(result.TemplateBase64);
        setImageSrc2("data:image/bmp;base64," + result.BMPBase64);
        handleVerifyFingerPrint(result.TemplateBase64);
      }
    } else {
      if (result.ErrorCode === 3) {
        toast.error("Please check your fingerprint device");
      } else if (result.ErrorCode === 54) {
        toast.error("Timeout, scan your finger again");
      } else {
        toast.error("Please scan your finger again");
      }
      console.log("Finger print error in Renewal fees page ", result);
    }
  };

  const errorFunc = (status) => {
    setIsFingerPrintScannerinProgress(false);
    toast.error("Please Check Secugen fingerprit service is working properly");
  };

  const callSGIFPGetData = (successCall, failCall) => {
    setIsFingerPrintScannerinProgress(true);
    const uri = "https://localhost:8000/SGIFPCapture";
    const params = `Timeout=10000&Quality=50&licstr=${encodeURIComponent(
      secugenLic
    )}&templateFormat=ISO`;

    fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        successCall(data);
      })
      .catch((error) => {
        failCall(error);
      });
  };

  const matchScore = (succFunction, failFunction) => {
    if (template1 === "" || template2 === "") {
      alert("Please scan two fingers to verify!!");
      return;
    }
    const uri = "https://localhost:8000/SGIMatchScore";

    const params = `template1=${encodeURIComponent(
      template1
    )}&template2=${encodeURIComponent(template2)}&licstr=${encodeURIComponent(
      secugenLic
    )}&templateFormat=ISO`;

    fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        succFunction(data);
      })
      .catch((error) => {
        failFunction(error);
      });
  };

  const succMatch = (result) => {
    const idQuality = quality;
    if (result.ErrorCode === 0) {
      if (result.MatchingScore >= idQuality) {
        toast.success(`FingerPrint Matched Successfully`);
      } else {
        toast.error("Not Matched Try Again");
      }
    } else {
      toast.error("Error Scanning Fingerprint");
    }
  };

  const failureFunc = (error) => {
    alert("On Match Process, failure has been called");
  };

  const errorCodeToString = (ErrorCode) => {
    // Implement the ErrorCodeToString function here
  };

  const navigate = useNavigate();

  useEffect(() => {
    setFeesFormData((prevState) => ({
      ...prevState,
      userId: userDeatils?.userId,
    }));

    console.log("User Id From Login Session", userDeatils?.userId);
  }, [userDeatils]);

  // ALREADY_PAID_CURRENT => details shown view-only; nothing due for the current session.
  const isViewOnly = welfareStatus?.resultCode === "ALREADY_PAID_CURRENT";

  // Slip can be printed whenever the advocate has a paid record
  // (already paid before, or just paid in this session).
  const canPrintSlip = isFeeSlipPrintable || !!paymentResult;

  // Membership validity badge (session aware, see utilities/membershipValidity.js)
  const membershipValidityInfo = getMembershipValidity(
    membershipFeesSession,
    membershipFeesDetails,
    membershipValidity
  );
  const isMembershipValid = membershipValidityInfo.isValid;
  const membershipValidityText = membershipValidityInfo.text;

  // Renewal/Verification validity: from the payment just made, or from check_advocate.
  const renewalValidTill = paymentResult?.validTill || welfareStatus?.validTill;
  const isRenewalValid = welfareStatus?.resultCode === "ALREADY_PAID_CURRENT";

  // Report view: rows after applying the search / member-type filters.
  const filteredReportRows = reportRows.filter((r) => {
    const searchText = reportSearch.toLowerCase();
    const matchesSearch =
      !reportSearch ||
      (r.advocate_bar_id || "").toLowerCase().includes(searchText) ||
      (r.name || "").toLowerCase().includes(searchText);
    const matchesType = !reportTypeFilter || r.member_type === reportTypeFilter;
    return matchesSearch && matchesType;
  });
  const reportMemberTypes = [
    ...new Set(reportRows.map((r) => r.member_type).filter(Boolean)),
  ];

  // Same blue as the existing header/sidebar theme.
  const welfareAccentColor = "#60a0ff";
  const welfareBtnStyle = {
    backgroundColor: welfareAccentColor,
    borderColor: welfareAccentColor,
  };

  return (
    <>
      {loading && <Loader />}
      {isFingerPrintScannerinProgress && <ScannerLoader />}

      <div
        className="row justify-content-center"
        style={{
          backgroundColor: welfareAccentColor,
          padding: "10px 0",
          margin: 0,
        }}
      >
        <div className="col-xxl-8 d-flex align-items-center justify-content-between">
          <span className="text-white fw-bold">
            <i className="ri-heart-2-fill me-2"></i>
            RENEWAL/VERIFICATION FEES FORM
          </span>
          <div>
            <MDBBtn
              color="light"
              size="sm"
              className="me-2"
              onClick={() => {
                handleViewWelfareReport();
              }}
            >
              Excel Report
            </MDBBtn>
            <MDBBtn
              color="light"
              size="sm"
              onClick={() => {
                navigate("/Fees");
              }}
            >
              Back to Fees
            </MDBBtn>
          </div>
        </div>
      </div>

      {showReport && (
        <div className="row justify-content-center mt-4 mb-2">
          <div className="col-xxl-10 col-11">
            <div className="card p-3">
              <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
                <h5 className="m-0" style={{ color: welfareAccentColor }}>
                  <b>
                    Renewal/Verification Paid Fees Report (
                    {filteredReportRows.length} of {reportRows.length})
                  </b>
                </h5>
                <div className="d-flex flex-wrap align-items-center gap-2">
                  <input
                    className="form-control form-control-sm"
                    style={{ width: "180px" }}
                    placeholder="Search Bar ID / Name"
                    value={reportSearch}
                    onChange={(e) => setReportSearch(e.target.value)}
                  />
                  <select
                    className="form-select form-select-sm"
                    style={{ width: "200px" }}
                    value={reportTypeFilter}
                    onChange={(e) => setReportTypeFilter(e.target.value)}
                  >
                    <option value="">All Member Types</option>
                    {reportMemberTypes.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                  <MDBBtn
                    size="sm"
                    style={welfareBtnStyle}
                    onClick={() => {
                      handleDownloadWelfareExcel();
                    }}
                  >
                    Download Excel
                  </MDBBtn>
                  <MDBBtn
                    size="sm"
                    color="secondary"
                    onClick={() => {
                      setShowReport(false);
                    }}
                  >
                    Close
                  </MDBBtn>
                </div>
              </div>
              <div style={{ maxHeight: "420px", overflow: "auto" }}>
                <table className="table table-striped table-bordered table-sm m-0">
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#fff",
                    }}
                  >
                    <tr>
                      <th>#</th>
                      <th>Bar ID</th>
                      <th>Name</th>
                      <th>Mobile No</th>
                      <th>Member Type</th>
                      <th>Fees ₹</th>
                      <th>Entry Date</th>
                      <th>Book No</th>
                      <th>Serial No</th>
                      <th>Receipt No</th>
                      <th>Valid Till</th>
                      <th>Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredReportRows.map((r, i) => (
                      <tr key={r.fee_id ?? i}>
                        <td>{i + 1}</td>
                        <td>{r.advocate_bar_id}</td>
                        <td>{r.name}</td>
                        <td>{r.mobileno}</td>
                        <td>{r.member_type}</td>
                        <td>{r.fees_amount}</td>
                        <td>
                          {r.entry_date
                            ? new Date(r.entry_date).toLocaleDateString("en-GB")
                            : ""}
                        </td>
                        <td>{r.book_no}</td>
                        <td>{r.sr_no}</td>
                        <td>{r.receipt_no}</td>
                        <td>
                          {r.valid_till
                            ? new Date(r.valid_till).toLocaleDateString("en-GB")
                            : ""}
                        </td>
                        <td
                          style={{
                            maxWidth: "260px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={r.permanent_address}
                        >
                          {r.permanent_address}
                        </td>
                      </tr>
                    ))}
                    {filteredReportRows.length === 0 && (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="row justify-content-center mb-2">
        <div className="col-xxl-8 mt-5">
          <h3
            className="text-center mb-5"
            style={{ color: welfareAccentColor }}
          >
            <b>Renewal/Verification Fees Submition</b>
          </h3>
        </div>
      </div>

      <div className="row justify-content-center mb-5">
        <div className="col-xxl-8">
          <div className="row justify-content-center">
            <div
              feedback="Please Enter Bar Id."
              invalid
              className="col-md-6 col-xl-4 col-xxl-3 mb-1 d-flex"
            >
              <MDBInput
                required
                value={barId}
                onChange={(e) => setbarId(e.target.value)}
                label="Enter Bar Id"
                type="text"
                name="barId"
                className="m-0"
                id="barId"
              />
            </div>

            {canPrintSlip ? (
              <div className="col-md-6 col-xl-5 col-xxl-4 mb-1">
                <MDBBtn
                  style={welfareBtnStyle}
                  onClick={() => {
                    handleGetAdvocateFeesVerificationData();
                  }}
                >
                  Get Data
                </MDBBtn>{" "}
              </div>
            ) : (
              <div className="col-md-4 mb-1 ">
                <MDBBtn
                  style={welfareBtnStyle}
                  onClick={() => {
                    handleGetAdvocateFeesVerificationData();
                  }}
                >
                  Get Data
                </MDBBtn>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Single persistent print block: shown for an already-paid advocate
          and kept on screen right after a successful payment. */}
      {canPrintSlip && (
        <div className="row justify-content-center mb-3">
          <div className="col-xxl-8 text-center">
            {paymentResult ? (
              <span className="badge rounded-pill bg-success p-2">
                Payment Successful — RECEIPT No: {paymentResult.recieptNo} |
                Valid Till:{" "}
                {paymentResult.validTill
                  ? new Date(paymentResult.validTill).toLocaleDateString(
                      "en-GB"
                    )
                  : "-"}
              </span>
            ) : (
              <span className="badge rounded-pill bg-success p-2">
                {welfareStatus?.message}
              </span>
            )}{" "}
            <MDBBtn
              style={welfareBtnStyle}
              size="sm"
              onClick={() => {
                navigate(`/WelfareSlip/${convertToUnderscoreFormat(barId)}`);
              }}
            >
              Print Renewal/Verification Slip
            </MDBBtn>
          </div>
        </div>
      )}

      <div className="row p-3 mt-4 justify-content-center ">
        {showFeesForm && (
          <>
            <div className="row justify-content-center mb-3">
              <div className="col-sm-6 col-md-3 col-xxl-2">
                <MDBInput
                  label="Enter Name"
                  id="name"
                  name="name"
                  value={userData?.name}
                  type="text"
                />
              </div>

              <div className="col-sm-6 col-md-3 col-xxl-2">
                <div className="input-group mb-3">
                  <select
                    className="form-select form-select-sm py-0"
                    style={{
                      height: "calc(1.5em + 0.75rem + 2px)",
                      width: "35%",
                    }}
                    value={userData?.relationshipType}
                    name="relationshipType"
                    id="relationshipType"
                  >
                    <option value="Son">S/O</option>
                    <option value="Daughter">D/O</option>
                    <option value="Wife">W/O</option>
                  </select>

                  <div className="input-group-append" style={{ width: "65%" }}>
                    <MDBInput
                      label="Relative Name"
                      id="relativeName"
                      name="relativeName"
                      value={userData?.relativeName}
                      type="text"
                    />
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-md-3 col-xxl-2">
                <MDBInput
                  label="Date of Birth"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  value={userData?.dateOfBirth}
                  type="date"
                />
              </div>
              <div className="col-sm-6 col-md-3 col-xxl-2">
                <MDBInput
                  label="Phone No"
                  id="mobileNo"
                  name="mobileNo"
                  value={userData?.mobileNo}
                  type="text"
                />
              </div>
            </div>

            {!isViewOnly && (
              <div className="row justify-content-center mb-2">
                <div className="col-xxl-8">
                  <label className="form-label me-3">
                    <strong>Payment For :</strong>
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="paymentMode"
                      id="paymentModePrevious"
                      value="1"
                      checked={paymentMode === 1}
                      disabled={isNewMemberInCurrentSession}
                      onChange={() => setPaymentMode(1)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="paymentModePrevious"
                    >
                      Previous Session ({previousSessionLabel})
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="paymentMode"
                      id="paymentModeCurrent"
                      value="2"
                      checked={paymentMode === 2}
                      onChange={() => setPaymentMode(2)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="paymentModeCurrent"
                    >
                      Current Session ({currentSessionLabel})
                    </label>
                  </div>
                  {isNewMemberInCurrentSession && (
                    <div className="text-muted small mt-1">
                      Registered in the current session, previous session fee
                      is not applicable.
                    </div>
                  )}
                </div>
              </div>
            )}

            {!isViewOnly && (
              <div className="row justify-content-center mb-2">
                <div className="col-xxl-8">
                  <div className="row">
                    <div className="col-md-3">
                      <label className="form-label" for="subscription__type">
                        Renewal/Verification Fee Type
                      </label>

                      <select
                        className="form-select"
                        onChange={handleWelfareTypeChange}
                        value={feesFormData?.membershipTypeId}
                        name="membershipTypeId"
                        id="membershipTypeId"
                      >
                        <option value="" selected>
                          Select
                        </option>
                        <option className="mb-3" value="1">
                          1 Year (₹200)
                        </option>
                        <option className="mb-3" value="2">
                          5 Years (₹1000)
                        </option>
                      </select>
                    </div>

                    <div className="col-md-3 mt-auto d-flex">
                      <MDBInput
                        value={feesFormData?.feesAmount}
                        name="feesAmount"
                        className="mb-0 d-inline"
                        id="feesAmount"
                        label="Total Amount in ₹"
                        type="number"
                        readOnly
                        required
                      />
                    </div>

                    <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                      {(welfareStatus?.resultCode === "PAY_PREVIOUS" ||
                        welfareStatus?.resultCode === "PAY_CURRENT") && (
                        <>
                          <strong>Renewal/Verification Fee Status : </strong>
                          <span
                            className={`badge rounded-pill ${
                              welfareStatus?.resultCode === "PAY_PREVIOUS"
                                ? "bg-danger"
                                : "bg-success"
                            }`}
                          >
                            {welfareStatus?.resultCode === "PAY_PREVIOUS"
                              ? `Previous Session Due (${previousSessionLabel})`
                              : `Current Session Due (${currentSessionLabel})`}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
             
            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                <div className="row">
                  <div className="col-md-6 mb-1">
                    <strong>Membership Validity : </strong>
                    <span
                      className={`badge rounded-pill ${
                        isMembershipValid ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {membershipValidityText || "Not Submitted"}
                    </span>
                  </div>
                  <div className="col-md-6 mb-1">
                    <strong>Renewal/Verification Valid Till : </strong>
                    <span
                      className={`badge rounded-pill ${
                        isRenewalValid ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {renewalValidTill
                        ? new Date(renewalValidTill).toLocaleDateString("en-GB")
                        : "Not Submitted"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                <div data-mdb-input-init className="form-outline">
                  <label className="form-label" htmlFor="textAreaExample3">
                    Permanent Address
                  </label>
                  <MDBTextArea
                    className="form-control"
                    id="permanentAddress"
                    name="permanentAddress"
                    value={userData?.permanentAddress}
                    rows="2"
                  ></MDBTextArea>
                </div>
              </div>
            </div>

            {!isViewOnly && (
              <div className="row justify-content-center mb-2">
                <div className="col-xxl-8">
                  {fingerPrintScanMessage ? (
                    <div className="text-danger">
                      Please verify your fingerprint before fees form submission
                    </div>
                  ) : (
                    <div className="text-success">
                      Your fingerprint is verified Please submit your fees form{" "}
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="row justify-content-center my-2">
              <div className="col-xxl-8">
                <div className="row">
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn>+</MDBBtn>
                      </MDBCardBody>
                      <div className="square-aspect-ratio-container">
                        <img
                          src={profileImage}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>
                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Photo
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn
                          disabled={isViewOnly}
                          onClick={() =>
                            callSGIFPGetData(successFunc2, errorFunc)
                          }
                        >
                          +
                        </MDBBtn>
                      </MDBCardBody>
                      <div className="square-aspect-ratio-container">
                        <img
                          src={imageSrc2}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>
                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Fingerprint
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn>+</MDBBtn>
                      </MDBCardBody>
                      <div className="square-aspect-ratio-container">
                        <img
                          src={signatureImage}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>

                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Signature
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                </div>
              </div>
            </div>

            {!isViewOnly && (
              <div className="row justify-content-center my-5">
                <div className="col-md-2 mb-1">
                  <MDBBtn
                    style={welfareBtnStyle}
                    onClick={(e) => {
                      handleSubmitFees(e);
                    }}
                  >
                    Submit
                  </MDBBtn>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default WelfareFees;